import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';

export class SmartInsightsRouteConfig extends PageRouteConfig {
  canAccessRouteFromContext() {
    return getters.session.getUserSettings().isSuperAdmin();
  }
}
